import setting from '@/setting.js'

let themeList = []

if(setting.layout.isThemeVIP){
    themeList = [
        {
            title: '* 梦幻蓝 *',
            name: 'dream-blue',
            backgroundImage: 'image/theme/dream-blue/bg.jpg',
            preview: 'image/theme/dream-blue/preview@2x.png'
        },
        {
            title: '* 金属蓝 *',
            name: 'metal-blue',
            backgroundImage: 'image/theme/metal-blue/bg.png',
            preview: 'image/theme/metal-blue/preview@2x.png'
        }
    ]
}

export default themeList
